import React from 'react';
import { usePath } from '../../../config/VideoAppContext';
import { FavoriteGuideTeaser } from '../FavoriteGuide/FavoriteGuideTeaser';
import { jsx as _jsx } from "react/jsx-runtime";
export const HomeFavoriteGuideTeaser = () => {
  const {
    homePath
  } = usePath();
  return /*#__PURE__*/_jsx(FavoriteGuideTeaser, {
    callbackUrl: homePath
  });
};